// @flow
import styled from 'styled-components';
import { darken, lighten } from 'polished';

export const StyledButton = styled.button`
    background-color: transparent;
    border: none;
    color: ${({ alternative, theme }) => (alternative ? theme.primaryFontColor : theme.mainBrandColor)};
    cursor: pointer;
    font-size: 1rem;
    outline: none;
    padding: 0;
    transition: color 0.3s;

    &:focus,
    &:hover {
        color: ${({ alternative, theme }) =>
            alternative ? lighten(0.1, theme.primaryFontColor) : lighten(0.1, theme.mainBrandColor)};
    }

    &:active {
        color: ${({ alternative, theme }) =>
            alternative ? darken(0.1, theme.primaryFontColor) : darken(0.1, theme.mainBrandColor)};
    }

    &:disabled {
        color: ${props => props.theme.mediumGrey};
        cursor: auto;
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/buttons/text/styles.js